import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  "employee.name": { value: "", matchMode: "contains" },
  employeeName: { value: "", matchMode: "contains" },
  year: { value: "", matchMode: "equals" },
  month: { value: "", matchMode: "equals" },
  version: { value: "", matchMode: "equals" },
  status: { value: "", matchMode: "equals" },
};

export const useFilterTimesheetStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
